const hofPlayers: string[] = ["P4", "Shiinka", "Eden", "Nouda", "Salzem", "Chaoxys", "Whiteshark67", "jahK", "DraZ", "Meechy", "Kuqus", "SpokeN", "aPPROX", "Aherys", "rxwd", "Dirza", "Fuziion", "JaKs", "Ra1kos", "LuZi"];

export default hofPlayers;
